import { Common_Setting_Config_Menu_Tooltip, Common_Setting_Filter_Command, Common_Setting_Refresh_Command } from "Agile/Scripts/Resources/TFS.Resources.AgileControls";
import { IPivotBarViewAction, PivotBarViewActionArea, PivotBarViewActionType } from "VSSUI/PivotBar";
import { VssIconType } from "VSSUI/VssIcon";

export namespace HubViewActions {
    export function getCommonSettings(onClick: React.MouseEventHandler<HTMLElement>): IPivotBarViewAction {
        return {
            key: "common-settings",
            iconProps: { iconName: "settings", iconType: VssIconType.fabric },
            important: true,
            onClick: onClick,
            ariaLabel: Common_Setting_Config_Menu_Tooltip,
            title: Common_Setting_Config_Menu_Tooltip,
            viewActionRenderArea: PivotBarViewActionArea.farRight
        };
    }

    export function getFilterAction(onClick: React.MouseEventHandler<HTMLElement>, filtered: boolean): IPivotBarViewAction {
        return {
            key: "work-item-filter-bar",
            actionType: PivotBarViewActionType.Command,
            ariaLabel: Common_Setting_Filter_Command,
            title: Common_Setting_Filter_Command,
            iconProps: { iconName: filtered ? "FilterSolid" : "Filter", iconType: VssIconType.fabric },
            important: true,
            onClick
        };
    }

    /** For use on Boards Analytics Reports - affordance for a refresh of data on pivot reports. */
    export function getRefreshAction(onClick: React.MouseEventHandler<HTMLElement>, viewActionArea?: PivotBarViewActionArea): IPivotBarViewAction {
        return {
            key: "analytics-refresh-action",
            actionType: PivotBarViewActionType.Command,
            ariaLabel: Common_Setting_Refresh_Command,
            title: Common_Setting_Refresh_Command,
            iconProps: { iconName: "Refresh", iconType: VssIconType.fabric },
            important: true,
            onClick,
            viewActionRenderArea: viewActionArea
        };
    }
}